import React, { FC, useCallback, useEffect, useState } from 'react'

import { ToggleCartContext } from '../lib/cart/context'
import { useLocationContext } from '../lib/pages/hooks/useLocationContext'

export const ToggleCartContextProvider: FC = ({ children }) => {
  const location = useLocationContext()
  const [isCartOpen, setIsCartOpen] = useState(false)
  const triggerElementRef = React.useRef<HTMLElement | null>(null)

  const showCart = useCallback((triggerElement?: HTMLElement | null) => {
    if (triggerElement) {
      triggerElementRef.current = triggerElement
    }
    setIsCartOpen(true)
  }, [])

  const hideCart = useCallback(() => {
    setIsCartOpen(false)
    if (triggerElementRef.current) {
      triggerElementRef.current.focus()
      triggerElementRef.current = null
    }
  }, [])

  const toggleCart = useCallback(
    (triggerElement?: HTMLElement | null) => {
      isCartOpen ? hideCart() : showCart(triggerElement)
    },
    [isCartOpen, hideCart, showCart],
  )

  useEffect(() => {
    if (location) {
      hideCart()
    }
  }, [hideCart, location])

  return (
    <ToggleCartContext.Provider value={{ isCartOpen, toggleCart, showCart, hideCart }}>
      {children}
    </ToggleCartContext.Provider>
  )
}
